import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
// import { useApiError } from '../useApiError';
export const useShopConfig = (Id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // const { set: setError } = useApiError();

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useShopConfig-${Id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useShopConfig-loading-${Id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useShopConfig-error-${Id}`);

  // 店铺配置
  const shopConfigGet = async () => {
    try {
      loading.value = true;
      result.value = await context.$xbuy.api.shopConfig(Id);
      // console.log('shopConfigGet-------------', result.value)
      error.value = null;
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return {
    load: shopConfigGet,
    result: computed(() => String(result.value)),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
